/**
 * Currency definition with hints for proper rendering.
 * @typedef {Object} CurrencyDefinition
 * @property {string} code
 *   Currency code according to ISO 4217.
 * @property {boolean} prepend
 *   Toggle currency symbol position.
 * @property {number} ratio
 *   Amount of cents in a single unit.
 * @property {(string|ReactElement)} symbol
 *   Currency symbol to be used for rendering.
 */

/**
 * Great British Pound currency definition
 * @name GBP
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const GBP = {
  code: 'GBP',
  prepend: true,
  ratio: 100,
  symbol: '£',
}

/**
 * Euro currency definition
 * @name EUR
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const EUR = {
  code: 'EUR',
  prepend: true,
  ratio: 100,
  symbol: '€',
}

/**
 * Norwegian krone currency definition
 * @name NOK
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const NOK = {
  code: 'NOK',
  prepend: false,
  ratio: 100,
  symbol: 'kr',
}

/**
 * Swedish krona currency definition
 * @name SEK
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const SEK = {
  code: 'SEK',
  prepend: false,
  ratio: 100,
  symbol: 'kr',
}

/**
 * United States dollar currency definition
 * @name USD
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const USD = {
  code: 'USD',
  prepend: true,
  ratio: 100,
  symbol: '$',
}

/**
 * Danish krona currency definition
 * @name DKK
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const DKK = {
  code: 'DKK',
  prepend: false,
  ratio: 100,
  symbol: 'kr',
}

/**
 * Indian rupee currency definition
 * @name INR
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const INR = {
  code: 'INR',
  prepend: true,
  ratio: 100,
  symbol: '₹',
}

/**
 * Canadian currency definition
 * @name
 * @kind constant
 * @type {CurrencyDefinition}
 */
export const CAD = {
  code: 'CAD',
  prepend: true,
  ratio: 100,
  symbol: 'C$',
}
